import DigitalAssetFileNameByIdRequestModelBase from '../_generated/modelBases/digital-asset-file-name-by-id-request-model-base';

export default class DigitalAssetFileNameByIdRequestModel extends DigitalAssetFileNameByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
